import React from 'react';
import PropTypes from 'prop-types';
import { scroller } from 'react-scroll';
import defer from 'lodash/defer';

import NumberInput from 'common/number-input';

const CustomAmount = ({ value, onChange, onSubmit }) => (
    <form
        onSubmit={e => {
            e.preventDefault();
            onSubmit();
        }}
        className="bg-white p-12 pt-8 rounded shadow-md"
        css={{ maxWidth: 400 }}
    >
        <label htmlFor="custom-amount" className="block text-16 text-gray-40 font-medium mb-4">
            Enter custom amount
        </label>
        <div className="flex items-center">
            <span className="text-gray-30 font-medium text-21 inline-block pr-4">$</span>
            <NumberInput
                id="custom-amount"
                value={value}
                name="custom-amount"
                className="input-default input-sm"
                onValueChange={onChange}
                onFocus={() =>
                    defer(() =>
                        scroller.scrollTo('custom-amount', {
                            duration: 500,
                            smooth: true,
                            offset: -175,
                        })
                    )
                }
                data-testid="amount-custom"
                autoFocus
            />
        </div>
        <input type="submit" className="hidden" />
    </form>
);

CustomAmount.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CustomAmount;
